import React from 'react';

import topIcon from 'images/marker.svg';
import * as S from './styles';
import { IProps } from './types';

export const ContactsTop: React.FC<IProps> = ({ contacts }) => (
  <S.Wrapper>
    <S.Icon src={topIcon} alt="contacts icon" />
    <S.Title>{contacts?.title}</S.Title>
    <S.SubTitle>{contacts?.description}</S.SubTitle>
  </S.Wrapper>
);
